import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { TranslationKey } from '@/types/i18n.types';

/**
 * Custom hook for translations with type safety
 * @returns Translation function with TypeScript support
 */
export const useI18n = () => {
  const { t, i18n } = useTranslation();

  // Memoizzata: `t` finisce nelle dependency array di parecchi useEffect
  // (ClientRequestModal, useServerData, useManualFetch...) perche' serve per i
  // messaggi di errore. Senza useCallback cambiava identita' a ogni render e
  // l'effect ripartiva in ciclo -- e' la causa della raffica di get_my_advisors
  // all'apertura della modale richiesta. L'identita' di `t` di react-i18next
  // cambia solo al cambio lingua, quindi le traduzioni restano reattive.
  const translate = useCallback(
    (key: TranslationKey, options?: any): string => t(key, options) as string,
    [t]
  );

  return {
    t: translate,
    language: i18n.language,
    changeLanguage: i18n.changeLanguage,
    i18n,
  };
};
